import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SelectField } from "@/lib/crm";
import { fmtDateLong as fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { LicenseDialog } from "@/components/assets/LicenseDialog";

export const FeeLicense = ({ fee, contract, companyName, live, onDone }) => {
  const { can } = useAuth();
  const [opts, setOpts] = useState(null);
  const [newOpen, setNewOpen] = useState(false);
  const lic = fee.license;
  const link = async (id) => {
    try { await api.post(`/contract-fees/${fee.id}/license`, { license_id: id || null }); toast.success(id ? "Licenza collegata" : "Licenza scollegata"); setOpts(null); onDone(); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  const load = () => api.get("/licenses", { params: { company_id: contract.company_id } })
    .then((r) => setOpts(r.data.items.map((x) => ({ key: x.id, label: `${x.code} · ${x.name}${x.end_date ? ` · scad. ${fmtDate(x.end_date)}` : ""}` })))).catch((e) => toast.error(errorMessage(e)));
  const preset = useMemo(() => ({ name: fee.description, unit: "altro", start_date: fee.start_date || "",
    end_date: fee.billed_until || fee.current_period?.end || "", renewal: "manuale" }), [fee]);
  useEffect(() => { setOpts(null); }, [fee.id]);
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-xs" data-testid={`fee-license-${fee.id}`}>
      <KeyRound className="h-3.5 w-3.5 text-slate-400" />
      {lic ? <Link to={`/licenze?open=${lic.id}`} className="font-semibold text-brand-700 hover:underline" data-testid={`fee-license-link-${fee.id}`}>{lic.code} · {lic.name}{lic.vendor ? ` (${lic.vendor})` : ""}{lic.end_date ? ` · scad. ${fmtDate(lic.end_date)}` : ""}</Link>
        : <span className="text-slate-500">Nessuna licenza collegata</span>}
      {live && can("licenses:read") && (opts ? (
        <div className="flex items-center gap-1"><SelectField value={lic?.id || ""} onChange={link} options={opts} allowNone="Nessuna" testId={`fee-license-select-${fee.id}`} className="w-64" />
          <Button size="sm" variant="ghost" onClick={() => setOpts(null)}>Chiudi</Button></div>
      ) : <>
        <Button size="sm" variant="ghost" className="h-7" onClick={load} data-testid={`fee-license-change-${fee.id}`}>{lic ? "Cambia" : "Collega esistente"}</Button>
        {!lic && can("licenses:create") && <Button size="sm" variant="ghost" className="h-7" onClick={() => setNewOpen(true)} data-testid={`fee-license-new-${fee.id}`}>Nuova licenza</Button>}
      </>)}
      <LicenseDialog open={newOpen} onOpenChange={setNewOpen} presetCompany={{ id: contract.company_id, name: companyName }} preset={preset} onSaved={(id) => { setNewOpen(false); link(id); }} />
    </div>
  );
};
